import { SystemEnvironmentKind } from '../constants/system-environment-kind';

// Hosts that mean a developer's own machine.
const DevHosts = ['localhost', '127.0.0.1', '::1', '[::1]'];

// A host containing any of these (any case) is a TEST system, e.g. `4spaces-web-test.tms-software.co.uk`
// or `tms-web-ui-uat.azurewebsites.net`. Anything that is neither Dev nor Test is Live.
const TestHostMarkers = ['-test', '-uat', '-staging'];

// ⚠️ FIXED ENGLISH - a deliberate exception to the `$localize` rule (decision D-13). A marking must
// read the same on screen, on paper and in an inbox, and the API marks documents and email
// subjects with these same words, so they are never translated.
const TestLabel = 'TEST SYSTEM';
const DevLabel = 'DEV';
const TestTitlePrefix = '[TEST] ';
const DevTitlePrefix = '[DEV] ';

export function systemEnvironmentKindForHost(host: string | null | undefined): SystemEnvironmentKind {
  const normalisedHost = (host ?? '').trim().toLowerCase();

  if (!normalisedHost) {
    return SystemEnvironmentKind.Live;
  }

  if (DevHosts.indexOf(normalisedHost) >= 0) {
    return SystemEnvironmentKind.Dev;
  }

  if (TestHostMarkers.some((marker) => normalisedHost.includes(marker))) {
    return SystemEnvironmentKind.Test;
  }

  return SystemEnvironmentKind.Live;
}

export function systemEnvironmentLabel(kind: SystemEnvironmentKind): string {
  switch (kind) {
    case SystemEnvironmentKind.Test:
      return TestLabel;
    case SystemEnvironmentKind.Dev:
      return DevLabel;
    default:
      return '';
  }
}

export function systemEnvironmentTitlePrefix(kind: SystemEnvironmentKind): string {
  switch (kind) {
    case SystemEnvironmentKind.Test:
      return TestTitlePrefix;
    case SystemEnvironmentKind.Dev:
      return DevTitlePrefix;
    default:
      return '';
  }
}
